import * as React from "react"
function CloseIcon (props){
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    color="blue"
    viewBox="-2.4 -2.4 28.8 28.8"
    width="1.5em"
    height="1.5em"
    {...props}
  >
    <rect
      width={28.8}
      height={28.8}
      x={-2.4}
      y={-2.4}
      strokeWidth={0}
      rx={14.4}
    />
    <g
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M10 12v5M14 12v5M4 7h16M6 10v8a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-8M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2H9V5Z" />
    </g>
  </svg>
  )
}
  export {CloseIcon};


